export const isDate = (value) => {
  return /^\d{4}-\d{2}-\d{2}$/.test(value);
};
